import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { stringByteLength } from "@/utils/string";
import { PostWorkValueError } from "./type";

export const checkStrLength = (str: string, max: number) => {
  const byteCount = stringByteLength(str, { zh: 2, emoji: 2, en: 1 });
  if (byteCount > max) return false;
  return true;
};

export const validators = {
  title: (title: string): true | PostWorkValueError => {
    const isValid = checkStrLength(title, 40);
    const { translate } = useTranslate();

    if (!isValid) {
      return {
        field: "title",
        msg: translate(Editor_Words["validate_title-over-limit"]),
      };
    }
    return isValid;
  },
  description: (description: string): true | PostWorkValueError => {
    const isValid = checkStrLength(description, 280);
    const { translate } = useTranslate();
    if (!isValid) {
      return {
        field: "description",
        msg: translate(Editor_Words["validate_description-over-limit"]),
      };
    }

    return isValid;
  },
};
